<template>
  <v-container class="contenedor-ppal">
    <v-overlay :value="sisi">
      <div class="loader"></div>
    </v-overlay>
    <!-- INFORMACION TOOLBAR  -->
    <v-card elevation="4" class="mb-5">
      <v-toolbar flat elevation="4">
        <v-card class="icon">
          <v-icon
            style="margin-left: 30px; margin-top: 25px"
            color="white"
            x-large=""
            >mdi-calendar-multiple</v-icon
          >
        </v-card>
        <div class="usuario">REPORTES POR FECHA</div>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <!-- CAMPOS PARA FILTRADO POR FECHA -->
    <v-card class="mt-5">
      <v-card-text>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 3" class="mb-2">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  color="#1D3C7F"
                  v-model="dateInit"
                  label="Fecha inicio"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                color="#294697"
                v-model="dateInit"
                @input="menu1 = false"
                locale="es"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 3" class="mb-2">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  color="#1D3C7F"
                  v-model="dateEnd"
                  label="Fecha final"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                color="#294697"
                v-model="dateEnd"
                @input="menu2 = false"
                locale="es"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 3" class="mb-2">
            <v-select
              v-model="selectedEmpresa"
              :items="empresasOptions"
              item-text="text"
              item-value="value"
              label="Empresa"
              dense
              outlined
              color="#1D3C7F"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            :cols="$vuetify.breakpoint.xs ? 12 : reportes.length != 0 ? 3 : 5"
            class="mb-2"
          >
            <v-btn
              :block="$vuetify.breakpoint.xs"
              :disabled="!dateInit"
              @click="searchReports"
              color="#294697"
              dark
              class="responsive-btn"
              style="width: 100%"
            >
              <v-icon left>mdi-magnify</v-icon>
              <span v-if="!$vuetify.breakpoint.xs">Consultar</span>
              <span v-else>Buscar</span>
            </v-btn>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 3" class="mb-2">
            <div v-if="reportes.length != 0" style="width: 100%">
              <v-btn
                :block="$vuetify.breakpoint.xs"
                :loading="loading3"
                :disabled="loading3"
                color="green darken-3"
                class="white--text responsive-btn"
                @click="downloadExcelJS"
                style="width: 100%"
              >
                <v-icon left> mdi-file-excel </v-icon>
                <span v-if="!$vuetify.breakpoint.xs">EXPORTAR EXCEL</span>
                <span v-else>Excel</span>
                <template v-slot:loader>
                  Exportando...
                  <span class="custom-loader">
                    <v-icon light>mdi-reload</v-icon>
                  </span>
                </template>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- DATA TABLE LISTADO DE REPORTES -->
    <v-text-field
      v-if="reportes != 0"
      v-model="search"
      append-icon="mdi-magnify"
      label="Filtrar busqueda"
      class="text-field"
      single-line
      color="#111c3d"
    ></v-text-field>
    <br />
    <!-- tabla donde se pintan los datos obtenidos del arreglo -->
    <v-data-table
      :headers="headers"
      :items="reportes"
      :search="search"
      style="border: 2px solid #111c3d"
      class="elevation-3"
    >
      <!-- Estado del caso -->
      <template v-slot:[`item.estado_caso`]="{ item }">
        <v-chip :color="getEstadoColor(item)" outlined dark>
          <div class="mt-2" v-if="item.oculto == 0 && item.cerrados == 0">
            ERRONEO
          </div>
          <div v-else>CORRECTO</div>
        </v-chip>
      </template>

      <!-- Columna de acciones (TODOS LOS ICONOS) -->
      <template v-slot:[`item.action`]="{ item }">
        <!-- Icono: Ver detalles (conversación) -->
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="#111c3d"
              class="mr-2"
              @click.prevent="verConversacion(item)"
            >
              mdi-wechat
            </v-icon>
          </template>
          <span>Ver detalles</span>
        </v-tooltip>

        <!-- Icono: Ver observación -->
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="light-green lighten-1"
              class="mr-2"
              @click.prevent="verObservacion(item)"
            >
              mdi-eye
            </v-icon>
          </template>
          <span>Ver observación</span>
        </v-tooltip>

        <!-- Icono: Ver imagen de cierre -->
        <v-tooltip v-if="item.cc_ruta && item.cc_ruta !== ''" right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="light-blue"
              class="mr-2"
              @click.prevent="verImagen(item)"
            >
              mdi-image
            </v-icon>
          </template>
          <span>Ver imagen de cierre</span>
        </v-tooltip>

        <!-- Icono: Ver historial -->
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="purple"
              class="mr-2"
              @click.prevent="verHistorial(item)"
            >
              mdi-timeline-clock
            </v-icon>
          </template>
          <span>Ver historial</span>
        </v-tooltip>

        <!-- Icono: Eliminar (solo para casos erróneos) -->
        <v-tooltip v-if="item.oculto == 0 && item.cerrados == 0" right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="red darken-2"
              @click.prevent="deleteReport(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Eliminar caso erróneo</span>
        </v-tooltip>
      </template>

      <template v-slot:no-data>
        <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined>
          No hay informacion para mostrar
        </v-alert>
      </template>
    </v-data-table>

    <!-- Timeline de historial -->
    <CaseHistoryTimeline
      :caseId="idCasoActual"
      :visible.sync="dialogHistorial"
    />

    <!-- Dialog de conversación -->
    <v-row justify="center">
      <v-dialog v-model="dialog2" max-width="500px" persistent>
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white">
              <v-icon color="white">mdi-message-bulleted</v-icon>
              DETALLE DE REPORTE
            </span>
          </v-card-title>
          <v-card-text>
            <div v-for="(chat, index) in chatItem" :key="index">
              <v-card class="mt-3 mx-auto" width="550">
                <v-card-subtitle v-if="chat.user == 'NOVA'" class="pb-0">
                  <p class="indigo--text text--darken-3">
                    <v-icon color="indigo darken-4" class="ml-5 mr-1"
                      >mdi-robot</v-icon
                    >
                    {{ chat.user }}
                  </p>
                </v-card-subtitle>
                <v-card-subtitle v-else class="d-flex justify-end">
                  <p class="deep-purple--text text--accent-3">
                    <v-icon color="deep-purple accent-4" class="ml-5 mr-1"
                      >mdi-face</v-icon
                    >
                    {{ chat.user }}
                  </p>
                </v-card-subtitle>
                <v-card-text v-if="chat.user == 'NOVA'" class="">
                  <p class="grey--text text--darken-1 text-left chat-message">
                    {{ chat.message }}
                  </p>
                </v-card-text>
                <v-card-text v-else class="d-flex justify-end">
                  <p class="grey--text text--darken-1 text-right chat-message">
                    {{ chat.message }}
                  </p>
                </v-card-text>
              </v-card>
            </div>
            <v-divider class="mt-5"></v-divider>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#1D3C7F"
              dark
              @click="verEvidencias(idCasoActual)"
              class="mr-2"
            >
              <v-icon left>mdi-image-multiple</v-icon>
              VER EVIDENCIAS
            </v-btn>
            <v-btn color="#1D3C7F" dark @click="dialog2 = false">CERRAR</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Dialog de observación -->
    <v-row justify="center">
      <v-dialog v-model="dialog3" max-width="500px" persistent>
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white">
              <v-icon color="white">mdi-message-bulleted</v-icon>
              OBSERVACIÓN DEL CASO
            </span>
          </v-card-title>
          <v-card-text class="pa-5">
            <p style="font-size: 18px; white-space: pre-wrap;">
              {{ observacion || "No se ingresó una observación para este caso" }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#1D3C7F" dark @click="dialog3 = false">CERRAR</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Dialog de evidencias -->
    <v-dialog v-model="dialogEvidencias" max-width="900px">
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-image-multiple</v-icon>
            Evidencias del caso #{{ idCasoActual }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div v-if="cargandoEvidencias" class="text-center my-5">
              <v-progress-circular
                indeterminate
                color="#294697"
              ></v-progress-circular>
              <p>Cargando evidencias...</p>
            </div>
            <div v-else-if="!evidencias.length" class="text-center my-5">
              <v-alert type="info" outlined>
                No hay evidencias disponibles para este caso.
              </v-alert>
            </div>
            <v-row v-else>
              <v-col
                v-for="(evidencia, index) in evidencias"
                :key="index"
                cols="12"
                sm="6"
                md="4"
              >
                <v-card outlined>
                  <template v-if="isImageUrl(evidencia.cc_ruta_evidencia)">
                    <v-img
                      :src="evidencia.cc_ruta_evidencia"
                      aspect-ratio="1"
                      class="grey lighten-2"
                      @click="verImagenCompleta(evidencia.cc_ruta_evidencia)"
                      style="cursor: pointer"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="#294697"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </template>
                  <template v-else>
                    <v-card
                      class="d-flex flex-column align-center justify-center pa-3"
                      style="cursor: pointer; aspect-ratio: 1; height: 100%"
                      @click="downloadFile(evidencia.cc_ruta_evidencia)"
                    >
                      <v-icon size="80" color="grey darken-1"
                        >mdi-file-document-outline</v-icon
                      >
                      <div
                        class="mt-2 text-caption grey--text text--darken-1 text-center"
                        style="word-break: break-all"
                      >
                        {{ getFileName(evidencia.cc_ruta_evidencia) }}
                      </div>
                    </v-card>
                  </template>
                  <v-card-text class="pa-2">
                    <small class="grey--text">{{
                      formatDate(evidencia.fecha_subida)
                    }}</small>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="closeEvidencias">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de imagen completa -->
    <v-dialog v-model="dialogImagenCompleta" max-width="90vw" fullscreen>
      <v-card flat>
        <v-toolbar dark color="#1D3C7F" flat>
          <v-btn icon dark @click="descargarImagen">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-toolbar-title>Evidencia</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogImagenCompleta = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text
          class="pa-0 d-flex justify-center align-center"
          style="height: calc(100vh - 64px); background-color: #000"
        >
          <img
            :src="imagenSeleccionada"
            style="max-height: 95vh; max-width: 95vw; object-fit: contain"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de imagen de cierre -->
    <v-dialog
      v-model="dialogImagenCierre"
      max-width="500px"
      max-height="400px"
      persistent
    >
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-image</v-icon>
            Evidencia del Caso
          </span>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-img v-if="cc_ruta" :src="cc_ruta" alt="Imagen"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#294697" dark @click="dialogImagenCierre = false"
            >CERRAR</v-btn
          >
          <v-btn color="#1D3C7F" dark @click="aumentarImagen">Aumentar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
      color="#111c3d"
      style="color: white"
    >
      {{ text }}
      <v-btn color="#111c3d" depressed @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import env from "@/components/env";
import swal from "sweetalert";
import XLSX from "xlsx";
import CaseHistoryTimeline from "./CaseHistoryTimeline.vue";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default {
  name: "Fecha",
  components: {
    CaseHistoryTimeline,
  },
  data: () => ({
    //Varibales de uso para el snackbar
    snackbar: false,
    y: "top",
    x: null,
    mode: "",
    timeout: 6000,
    text: "",
    //Variables de uso para obtener lista de fechas
    dateInit: "",
    dateEnd: new Date().toISOString().substr(0, 10),
    menu1: false,
    menu2: false,
    sisi: false,
    headers: [
      {
        text: "Numero de caso",
        value: "cc_id_caso",
        align: "center",
        class: "column",
      },
      {
        text: "Requerimiento",
        value: "cc_nombre_requerimiento",
        align: "center",
        class: "column",
      },
      {
        text: "Estado",
        value: "estado_caso", // Cambiado de "oculto" a "estado_caso"
        align: "center",
        class: "column",
      },
      {
        text: "IP",
        align: "left",
        value: "ip",
        align: "center",
        class: "column",
      },
      {
        text: "Municipio",
        value: "municipio",
        align: "center",
        class: "column",
      },
      {
        text: "Punto",
        value: "punto",
        align: "center",
        class: "column",
      },
      {
        text: "Empresa",
        value: "nombreEmpresa",
        align: "center",
        class: "column",
      },
      {
        text: "Fecha apertura",
        value: "fecha_inicio",
        align: "center",
        class: "column",
      },
      {
        text: "Fecha cierre",
        value: "fecha_cierre",
        align: "center",
        class: "column",
      },
      {
        text: "Especialista",
        value: "nombre",
        align: "center",
        class: "column",
      },
      {
        text: "Acciones",
        value: "action",
        sortable: false,
        align: "center",
        class: "column",
      },
    ],
    reportes: [],
    search: "",
    dialog: false,
    dialogHistorial: false,
    dialog3: false, // Nuevo dialog para observación
    observacion: "",
    idCasoActual: null,

    //Variables de uso para exportar a excel
    nameFile: "",
    loader: null,
    loading3: false,
    chatItem: [],
    dialog2: false,
    dialogEvidencias: false,
    cargandoEvidencias: false,
    evidencias: [],
    imagenSeleccionada: "",
    dialogImagenCompleta: false,
    dialogImagenCierre: false,
    cc_ruta: "",
    idCargo: parseInt(localStorage.getItem("idCargo")) || 0,
    idArea: parseInt(localStorage.getItem("idArea")) || 0,
    selectedEmpresa: 0, // 0 = Todas las empresas
    empresasOptions: [
      { text: "Todas", value: 0 },
      { text: "FACILISIMO", value: 1 },
      { text: "APOSTAR", value: 2 },
    ],
  }),
  watch: {
    // Watcher para consultar automáticamente cuando cambia el filtro de empresa
    selectedEmpresa(newVal, oldVal) {
      if (
        this.dateInit &&
        this.dateEnd &&
        this.reportes.length > 0 &&
        oldVal !== undefined &&
        newVal !== oldVal
      ) {
        this.searchReports();
      }
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
  },
  computed: {
    // Computed property para filtrar reportes según el search
    reportesFiltrados() {
      if (!this.search || this.search.trim() === "") {
        return this.reportes;
      }
      const searchLower = this.search.toLowerCase();
      return this.reportes.filter((reporte) => {
        return (
          (reporte.cc_id_caso &&
            reporte.cc_id_caso.toString().includes(searchLower)) ||
          (reporte.cc_nombre_requerimiento &&
            reporte.cc_nombre_requerimiento
              .toLowerCase()
              .includes(searchLower)) ||
          (reporte.cc_nombre_area &&
            reporte.cc_nombre_area.toLowerCase().includes(searchLower)) ||
          (reporte.punto &&
            reporte.punto.toLowerCase().includes(searchLower)) ||
          (reporte.nombre_asesor &&
            reporte.nombre_asesor.toLowerCase().includes(searchLower)) ||
          (reporte.nombre &&
            reporte.nombre.toLowerCase().includes(searchLower)) ||
          (reporte.nombreEmpresa &&
            reporte.nombreEmpresa.toLowerCase().includes(searchLower))
        );
      });
    },
  },
  methods: {
    obtenerUser() {
      const id = localStorage.getItem("id");
      if (id) {
        axios
          .get(`${env.endpoint}usuarios/getUser?id=${id}`)
          .then((res) => {
            if (res.data && res.data.length > 0) {
              this.idCargo = res.data[0].idCargo;
              this.idArea = res.data[0].idArea;
              localStorage.setItem("idCargo", this.idCargo.toString());
              localStorage.setItem("idArea", this.idArea.toString());
            }
          })
          .catch((error) => {
            console.error("Error obteniendo usuario:", error);
          });
      }
    },
    getEstadoColor(item) {
      if (item.oculto == 0 && item.cerrados == 0) return "red darken-2";
      else return "green darken-3";
    },
    prioridad(value) {
      switch (value) {
        case "1":
          return "BAJA";
        case "2":
          return "MEDIA";
        case "3":
          return "ALTA";
      }
    },
    estado(value) {
      switch (value) {
        case "0":
          return "ABIERTO";
        case "1":
          return "SOLUCIONADO";
        case "2":
          return "ASIGNADO";
        case "3":
          return "SUSPENDIDO";
        case "4":
          return "VENCIDO";
        case "5":
          return "ANULADO";
      }
    },

    downloadExcel() {
      this.loading3 = true;
      const reportes = [];
      try {
        for (let i = 0; i < this.reportes.length; i++) {
          const item = {};
          item["ID"] = this.reportes[i].cc_id_caso;
          item["Cédula quien radica"] = this.reportes[i].cedula_asesor;
          item["Nombre quien radica"] = this.reportes[i].nombre_asesor;
          item["Área de servicio"] = this.reportes[i].cc_nombre_area;
          item["Punto"] = this.reportes[i].punto;
          item["Requerimiento"] = this.reportes[i].cc_nombre_requerimiento;
          item["Vencidos"] =
            this.reportes[i].vencido == "1" ? "Vencido" : "No Vencido";
          item["Estado"] = this.estado(this.reportes[i].cerrados);
          item["Fecha inicio"] = this.reportes[i].fecha_inicio;
          item["Fecha cierre"] = this.reportes[i].fecha_cierre;
          item["Fecha vencimiento"] = this.reportes[i].fecha_vencimiento;
          item["Nombre responsable"] = this.reportes[i].nombre;
          item["Observaciones"] = this.reportes[i].observaciones;
          item["Conversación"] = this.reportes[i].conversacion;
          item["Prioridad"] = this.prioridad(
            this.reportes[i].cc_prioridad_requerimiento,
          );
          if (this.reportes[i].oculto == 0 && this.reportes[i].cerrados == 0) {
            item["Estado del caso"] = "ERRONEO";
          } else {
            item["Estado del caso"] = "CORRECTO";
          }
          reportes.push(item);
        }
      } catch (error) {
        console.log(error);
        this.loading3 = false;
      }
      const data = XLSX.utils.json_to_sheet(reportes);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `Reportes${this.dateInit}-al-${this.dateEnd}.xlsx`);
      this.loading3 = false;
    },
    
    async downloadExcelJS() {
      this.loading3 = true;
      const datosFiltrados = this.reportesFiltrados;

      try {
        const workbook = new ExcelJS.Workbook();
        const casosPorArea = {};

        datosFiltrados.forEach((caso) => {
          const nombreArea =
            caso.cc_nombre_area || `ÁREA ${caso.cc_id_area || "SIN ÁREA"}`;

          if (!casosPorArea[nombreArea]) {
            casosPorArea[nombreArea] = [];
          }
          casosPorArea[nombreArea].push(caso);
        });
        
        const crearHoja = async (ws, datos, nombre) => {
          const empresasEnDatos = new Set();
          datos.forEach((r) => {
            if (r.nombreEmpresa) {
              const empresa = r.nombreEmpresa.toUpperCase();
              if (
                empresa.includes("FACILISIMO") ||
                empresa.includes("FACILISIM")
              ) {
                empresasEnDatos.add("FACILISIMO");
              } else if (empresa.includes("APOSTAR")) {
                empresasEnDatos.add("APOSTAR");
              }
            } else if (r.idEmpresa) {
              if (r.idEmpresa == 1) {
                empresasEnDatos.add("FACILISIMO");
              } else if (r.idEmpresa == 2) {
                empresasEnDatos.add("APOSTAR");
              }
            }
          });

          const tieneFacilisimo = empresasEnDatos.has("FACILISIMO");
          const tieneApostar = empresasEnDatos.has("APOSTAR");
          const tieneAmbas = tieneFacilisimo && tieneApostar;

          const novaLogo = await fetch(
            require("@/assets/nova/Logo_nova.png"),
          ).then((r) => r.arrayBuffer());
          const novaId = workbook.addImage({
            buffer: novaLogo,
            extension: "png",
          });
          ws.addImage(novaId, {
            tl: { col: 0, row: 0 },
            ext: { width: 120, height: 60 },
          });

          if (tieneFacilisimo && !tieneApostar) {
            const facilisimoLogo = await fetch(
              require("@/assets/LOGO-FACILISIMO-GRIS.png"),
            ).then((r) => r.arrayBuffer());
            const facilisimoId = workbook.addImage({
              buffer: facilisimoLogo,
              extension: "png",
            });
            ws.addImage(facilisimoId, {
              tl: { col: 9, row: 0 },
              ext: { width: 120, height: 60 },
            });
          } else if (tieneApostar && !tieneFacilisimo) {
            const apostarLogo = await fetch(
              require("@/assets/nova/LOGO APOSTAR-06.png"),
            ).then((r) => r.arrayBuffer());
            const apostarId = workbook.addImage({
              buffer: apostarLogo,
              extension: "png",
            });
            ws.addImage(apostarId, {
              tl: { col: 9, row: 0 },
              ext: { width: 120, height: 60 },
            });
          } else if (tieneAmbas) {
            const facilisimoLogo = await fetch(
              require("@/assets/LOGO-FACILISIMO-GRIS.png"),
            ).then((r) => r.arrayBuffer());
            const apostarLogo = await fetch(
              require("@/assets/nova/LOGO APOSTAR-06.png"),
            ).then((r) => r.arrayBuffer());
            const facilisimoId = workbook.addImage({
              buffer: facilisimoLogo,
              extension: "png",
            });
            const apostarId = workbook.addImage({
              buffer: apostarLogo,
              extension: "png",
            });
            ws.addImage(facilisimoId, {
              tl: { col: 7, row: 0 },
              ext: { width: 120, height: 60 },
            });
            ws.addImage(apostarId, {
              tl: { col: 9, row: 0 },
              ext: { width: 120, height: 60 },
            });
          } else {
            const apostarLogo = await fetch(
              require("@/assets/nova/LOGO APOSTAR-06.png"),
            ).then((r) => r.arrayBuffer());
            const apostarId = workbook.addImage({
              buffer: apostarLogo,
              extension: "png",
            });
            ws.addImage(apostarId, {
              tl: { col: 9, row: 0 },
              ext: { width: 120, height: 60 },
            });
          }

          if (tieneAmbas) {
            ws.mergeCells("C1", "F2");
          } else {
            ws.mergeCells("C1", "I2");
          }
          ws.getCell("C1").value = `Reporte de Casos - ${nombre}`;
          ws.getCell("C1").alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          ws.getCell("C1").font = {
            size: 18,
            bold: 1,
            color: { argb: "FFFFFFFF" },
          };
          
          for (let row = 1; row <= 2; row++) {
            for (let col = 1; col <= 19; col++) {
              const cell = ws.getCell(row, col);
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FF294697" },
              };
            }
          }
          ws.getRow(1).height = 30;
          ws.getRow(2).height = 30;
          
          ws.addRow([]);
          
          const esCartera = nombre.toUpperCase().includes('CARTERA');
          
          if (esCartera) {
            ws.addRow([
              "ID",
              "Cédula",
              "Nombre Completo",
              "Área de servicio",
              "Punto de venta",
              "Empresa",
              "Requerimiento",
              "Vencidos",
              "Estado",
              "Fecha inicio",
              "Fecha cierre",
              "Fecha vencimiento",
              "Nombre responsable",
              "Observaciones",
              "Prioridad",
              "Estado del caso",
              "Escalado por",
              "Área Escalamiento",
              "CONVERSACIÓN"
            ]);
          } else {
            ws.addRow([
              "ID",
              "Cédula",
              "Nombre Completo",
              "Área de servicio",
              "Punto de venta",
              "Empresa",
              "Requerimiento",
              "Vencidos",
              "Estado",
              "Fecha inicio",
              "Fecha cierre",
              "Fecha vencimiento",
              "Nombre responsable",
              "Observaciones",
              "Prioridad",
              "Estado del caso",
              "Escalado por",
              "Área Escalamiento"
            ]);
          }
          
          ws.getRow(4).eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FF1D3C7F" },
            };
            cell.font = { color: { argb: "FFFFFFFF" }, bold: true };
            cell.border = {
              top: { style: "medium", color: { argb: "FF000000" } },
              left: { style: "medium", color: { argb: "FF000000" } },
              bottom: { style: "medium", color: { argb: "FF000000" } },
              right: { style: "medium", color: { argb: "FF000000" } },
            };
          });
          
          datos.forEach((r) => {
            const estadoCaso = r.oculto == 0 && r.cerrados == 0 ? "ERRONEO" : "CORRECTO";
            
            let escaladoPor = "NO ESCALADO";
            let areaEscalamiento = "NO ESCALADO";
            
            if (r.escalamiento) {
              try {
                const escJson = JSON.parse(r.escalamiento);
                if (escJson.areaOrigen && escJson.areaOrigen !== "") {
                  areaEscalamiento = escJson.areaOrigen;
                } else if (escJson.area_origen && escJson.area_origen !== "") {
                  areaEscalamiento = escJson.area_origen;
                } else if (escJson.area && escJson.area !== "") {
                  areaEscalamiento = escJson.area;
                }
                
                if (escJson.nombreUsuario && escJson.nombreUsuario !== "") {
                  escaladoPor = escJson.nombreUsuario;
                } else if (escJson.escalado_por && escJson.escalado_por !== "") {
                  escaladoPor = escJson.escalado_por;
                } else if (escJson.idUsuario && escJson.idUsuario !== "") {
                  escaladoPor = "ID: " + escJson.idUsuario;
                } else if (areaEscalamiento !== "NO ESCALADO") {
                  escaladoPor = "ESCALADO (sin detalle)";
                }
              } catch (e) {
                if (areaEscalamiento === "NO ESCALADO") {
                  escaladoPor = "ESCALADO";
                  areaEscalamiento = "Área desconocida";
                }
              }
            }
            
            if (esCartera) {
              const conversacionOriginal = r.conversacion_desbloqueo || "";
              
              // Crear RichText con preguntas en negrita arriba y respuesta abajo
              const richText = [];
              if (conversacionOriginal) {
                // Separar por \n
                const lineas = conversacionOriginal.split('\\n');
                
                lineas.forEach((linea, idx) => {
                  if (linea.trim()) {
                    // Separar pregunta y respuesta por |||
                    const partes = linea.split('|||');
                    if (partes.length >= 2) {
                      const pregunta = partes[0];
                      const respuesta = partes[1];
                      
                      // Pregunta en negrita + salto de línea
                      richText.push({ text: pregunta, font: { bold: true } });
                      richText.push({ text: "\n", font: { bold: false } });
                      // Respuesta normal
                      richText.push({ text: respuesta, font: { bold: false } });
                    } else {
                      richText.push({ text: linea, font: { bold: false } });
                    }
                  }
                  // Doble salto de línea entre cada bloque
                  if (idx < lineas.length - 1) {
                    richText.push({ text: "\n\n", font: { bold: false } });
                  }
                });
              }
              
              const fila = ws.addRow([
                r.cc_id_caso,
                r.cedula_asesor,
                r.nombre_asesor,
                r.cc_nombre_area,
                r.punto || "SIN CONFIGURAR",
                r.nombreEmpresa || "SIN EMPRESA",
                r.cc_nombre_requerimiento,
                r.vencido == 1 ? "Vencido" : "No Vencido",
                this.estado(r.cerrados),
                r.fecha_inicio,
                r.fecha_cierre,
                r.fecha_vencimiento,
                r.nombre,
                r.observaciones,
                this.prioridad(r.cc_prioridad_requerimiento),
                estadoCaso,
                escaladoPor,
                areaEscalamiento,
                richText.length ? { richText } : ""
              ]);
              
              const celdaConv = fila.getCell(19);
              celdaConv.alignment = { wrapText: true, vertical: 'top' };
              
            } else {
              ws.addRow([
                r.cc_id_caso,
                r.cedula_asesor,
                r.nombre_asesor,
                r.cc_nombre_area,
                r.punto || "SIN CONFIGURAR",
                r.nombreEmpresa || "SIN EMPRESA",
                r.cc_nombre_requerimiento,
                r.vencido == 1 ? "Vencido" : "No Vencido",
                this.estado(r.cerrados),
                r.fecha_inicio,
                r.fecha_cierre,
                r.fecha_vencimiento,
                r.nombre,
                r.observaciones,
                this.prioridad(r.cc_prioridad_requerimiento),
                estadoCaso,
                escaladoPor,
                areaEscalamiento
              ]);
            }
          });
          
          // Ajustar anchos de columnas
          ws.columns.forEach((col) => {
            col.width = 30;
          });

          // CONVERSACIÓN: wrapText para que no se desborde
          if (esCartera) {
            ws.getColumn(19).eachCell((cell, rowNumber) => {
              if (rowNumber > 4) {
                cell.alignment = {
                  wrapText: true,
                  vertical: "top"
                };
                ws.getRow(rowNumber).height = 15;
              }
            });
          }
        };

        const areasOrdenadas = Object.keys(casosPorArea).sort();

        for (const nombreArea of areasOrdenadas) {
          const casosArea = casosPorArea[nombreArea];
          if (casosArea.length > 0) {
            let nombreHoja = nombreArea
              .substring(0, 31)
              .replace(/[\\\/\?\*\[\]]/g, "_")
              .trim();

            if (!nombreHoja) {
              nombreHoja = "SIN AREA";
            }

            const ws = workbook.addWorksheet(nombreHoja);
            await crearHoja(ws, casosArea, nombreArea);
          }
        }
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
          new Blob([buffer]),
          `Reportes${this.dateInit}-al-${this.dateEnd}.xlsx`,
        );
      } catch (e) {
        console.error("Error exportando Excel:", e);
        this.text = "Error exportando Excel: " + e.message;
        this.snackbar = true;
      }
      this.loading3 = false;
    },
    
    /**
     * Metodo que busca todos los reportes por dos fechas
     */
    searchReports() {
      this.sisi = true;
      const fechaInicio = this.dateInit;
      const fechaCierre = this.dateEnd;
      const id = localStorage.getItem("id");

      if (fechaInicio > fechaCierre) {
        this.snackbar = true;
        this.text = "Error, fecha de inicio mayor a la final";
        this.dateInit = "";
        this.reportes = [];
        this.nameFile = "";
        this.sisi = false;
        return;
      }

      const idEmpresa =
        this.selectedEmpresa !== null && this.selectedEmpresa !== undefined
          ? parseInt(this.selectedEmpresa)
          : 0;

      const url = `${env.endpoint}callcenter/reporteFechaCall?idUsuario=${id}&fechaInicio=${fechaInicio} 00:00:00&fechaFinal=${fechaCierre} 23:59:59&idEmpresa=${idEmpresa}`;

      console.log("Consultando:", url);

      axios
        .get(url)
        .then((res) => {
          this.sisi = false;
          let data = res.data || [];

          if (this.idCargo === 4) {
            data = data.filter(
              (r) =>
                r.cc_nombre_area &&
                r.cc_nombre_area.toUpperCase().includes("SISTEMAS"),
            );
          }

          this.reportes = data;
          this.nameFile = `casos ${fechaInicio} al ${fechaCierre}`;
        })
        .catch((error) => {
          console.error("Error:", error);
          this.sisi = false;
          this.snackbar = true;
          this.text = "Error al obtener los reportes";
        });
    },
    
    /**
     * Metodo que activa la modal y muestra la conversacion
     */
    verConversacion(item) {
      this.dialog2 = true;
      this.idCasoActual = item.cc_id_caso;
      this.chatItem =
        typeof item.conversacion === "string"
          ? JSON.parse(item.conversacion)
          : item.conversacion;
    },
    
    /**
     * Metodo para ver la observación (NUEVO)
     */
    verObservacion(item) {
      this.dialog3 = true;
      this.observacion = item.observaciones;
    },
    
    verHistorial(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorial = true;
    },
    
    /**
     * Metodo que elimina un reporte que no fue cerrado correctamente por el bot
     */
    deleteReport(item) {
      swal({
        title: "Este registro sera eliminado permanentemente.",
        text: "Una vez eliminado no se podra recuperar.",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axios
            .get(`${env.endpoint}callcenter/delete_caso?id=${item.cc_id_caso}`)
            .then((res) => {
              this.searchReports();
            })
            .catch((error) => {
              // console.log();
            });
          swal("Registro eliminado con exito!", {
            icon: "success",
          });
        } else {
          swal("Proceso de eliminacion cancelado");
        }
      });
    },
    
    getColor(oculto, cerrados) {
      if (oculto == 0 && cerrados == 0) return "red darken-2";
      else return "green darken-3";
    },
    
    verEvidencias(idCaso) {
      this.idCasoActual = idCaso;
      this.dialogEvidencias = true;
      this.cargandoEvidencias = false;
      this.evidencias = [];
      axios
        .get(`${env.endpointTraerEvidencias}?cc_id_caso=${idCaso}`)
        .then((response) => {
          this.evidencias = response.data.evidencias;
        })
        .catch((error) => {
          this.text = "Error al cargar las evidencias";
          this.snackbar = true;
        })
        .finally(() => {
          this.cargandoEvidencias = false;
        });
    },
    
    closeEvidencias() {
      this.dialogEvidencias = false;
      this.evidencias = [];
    },
    
    verImagenCompleta(url) {
      this.imagenSeleccionada = url;
      this.dialogImagenCompleta = true;
    },
    
    descargarImagen() {
      const link = document.createElement("a");
      link.href = this.imagenSeleccionada;
      link.download = this.imagenSeleccionada.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    
    verImagen(item) {
      if (item.cc_ruta && item.cc_ruta !== '') {
        const rutas = item.cc_ruta.split(',').map(r => r.trim()).filter(r => r);
        if (rutas.length > 0) {
          this.cc_ruta = rutas[0];
          this.dialogImagenCierre = true;
        }
      }
    },
    
    aumentarImagen() {
      this.imagenSeleccionada = this.cc_ruta;
      this.dialogImagenCierre = false;
      this.dialogImagenCompleta = true;
    },
    
    isImageUrl(url) {
      if (!url) return false;
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },
    
    getFileName(url) {
      if (!url) return "Archivo";
      try {
        const fullPath = new URL(url).pathname;
        return fullPath.substring(fullPath.lastIndexOf("/") + 1);
      } catch (e) {
        const parts = url.split("/");
        return parts[parts.length - 1] || "Archivo";
      }
    },
    
    formatDate(dateString) {
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateString).toLocaleDateString("es-ES", options);
    },
  },
};
</script>

<style>
.text-field {
  border: 2px solid #111c3d;
  padding: 5px;
  border-radius: 5px;
}

.contenedor-ppal {
  border: 1px solid #111c3d;
  padding-bottom: 40px !important;
  border-radius: 5px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #2981ec;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}
@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}

.responsive-btn {
  min-width: 120px;
  font-size: 1rem;
  padding: 0 16px;
}
@media (max-width: 600px) {
  .responsive-btn {
    width: 100% !important;
    min-width: unset !important;
    font-size: 0.95rem !important;
    margin-bottom: 8px !important;
    padding: 10px 0 !important;
  }
  .v-col {
    padding-left: 4px !important;
    padding-right: 4px !important;
    margin-bottom: 8px !important;
  }
  .v-text-field {
    font-size: 0.95rem !important;
  }
  .v-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
.chat-message {
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-width: 100%;
}
</style>
